import { render } from "./base-button.vue?vue&type=template&id=0adcedc2&scoped=true"
const script = {}

import "./base-button.vue?vue&type=style&index=0&id=0adcedc2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adcedc2"]])

export default __exports__